import React, {Component} from 'react';
import {connect} from "react-redux";
import './index.scss';
import {checkSession} from "../../api/api";
import * as azureAdActions from "../../actions/azure";
import {AzureAdTableLoading} from "./AzureAdTableLoading";
import {AzureAdTable} from "./AzureAdTable";
import {AzureAdTableEmpty} from "./AzureAdTableEmpty";

/**
 * AzureAdList - display a table of Azure AD clients
 */
class AzureAdList extends Component {
  getAzureAdList = () => {
    this.props.getAzureAdList();
  };
  deleteAzureAd = (id) => {
    this.props.deleteAzureAd(id);
  };
  getAzureAdJson = () => {
    this.props.getAzureAdJson();
  };
  handleJsonClick = () => {
    this.getAzureAdJson();
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      this.getAzureAdList();
    }
  }

  sortByIdDescending(azureAdList) {
    return azureAdList.sort((a, b) => (a.id, b.id) ? -1 : 1);
  }

  render() {
    const {
      fetchingAzureAdList,
      azureAdList,
    } = this.props;

    return (
        <div className="container GetAzureAdList-container">
          {azureAdList.length !== 0 ? (
              <AzureAdTable
                  azureAdList={this.sortByIdDescending(azureAdList)}
                  deleteAzureAd={this.deleteAzureAd}
                  handleJsonClick={this.handleJsonClick}
              />
          ) : fetchingAzureAdList ? (
              <AzureAdTableLoading/>
          ) : (
              <AzureAdTableEmpty/>
          )}
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    fetchingAzureAdList: state.azure.fetchingAzureAdList,
    azureAdList: state.azure.azureAdList,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAzureAdList: () => {
      dispatch(azureAdActions.getAzureAdList());
    },
    deleteAzureAd: (id) => {
      dispatch(azureAdActions.deleteAzureAd(id));
    },
    getAzureAdJson: () => {
      dispatch(azureAdActions.getAzureAdJson());
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AzureAdList);


// WEBPACK FOOTER //
// ./src/components/AzureAdList/index.js